import React from "react";
import { useTranslation } from "react-i18next";

interface GlobalLoaderProps {
  message?: string;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({ message }) => {
  const { t } = useTranslation();
  const displayMessage = message || 'loading' /* TODO: translate inline */;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center" style={{ backgroundColor: '#fff5ebff' }}>
      <div className="text-center space-y-6">
        {/* Logo con círculo giratorio */}
        <div className="relative inline-block">
          {/* Círculo exterior giratorio */}
          <svg
            className="animate-spin"
            width="120"
            height="120"
            viewBox="0 0 120 120"
            style={{ animationDuration: '2s' }}
          >
            <circle
              cx="60"
              cy="60"
              r="54"
              stroke="currentColor"
              strokeWidth="3"
              fill="none"
              className="text-gray-200 dark:text-gray-800"
            />
            <circle
              cx="60"
              cy="60"
              r="54"
              stroke="currentColor"
              strokeWidth="3"
              fill="none"
              strokeDasharray="339.292"
              strokeDashoffset="84.823"
              strokeLinecap="round"
              style={{ color: '#055590ff' }}
            />
          </svg>

          {/* Logo en el centro */}
          <div className="absolute inset-0 flex items-center justify-center">
            <img
              src="/images/logo/logo-icon.svg"
              alt="Logrit"
              className="w-16 h-16 animate-pulse"
              style={{ animationDuration: '2s' }}
            />
          </div>
        </div>

        <div className="text-xl font-black text-gray-900 dark:text-white tracking-wide">
          Logrit
        </div>

        {/* Mensaje */}
        <div className="space-y-3">
          <p className="text-lg font-black text-gray-800 dark:text-gray-200">
            {displayMessage}
          </p>
          <div className="flex items-center justify-center gap-1.5">
            <div
              className="w-2 h-2 rounded-full animate-bounce"
              style={{ backgroundColor: '#aad08cff', animationDelay: "0ms" }}
            ></div>
            <div
              className="w-2 h-2 rounded-full animate-bounce"
              style={{ backgroundColor: '#fdbc52ff', animationDelay: "150ms" }}
            ></div>
            <div
              className="w-2 h-2 rounded-full animate-bounce"
              style={{ backgroundColor: '#ef6e6bff', animationDelay: "300ms" }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
